export default "__VITE_ASSET__D5ik9jdu__"